import CheckBox from './CheckBox';

export default CheckBox;



// WEBPACK FOOTER //
// ./src/components/CheckBox/index.ts